"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Viewport = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Viewport = exports.Viewport = /*#__PURE__*/function () {
  function Viewport() {
    _classCallCheck(this, Viewport);
    _defineProperty(this, "window", window);
    _defineProperty(this, "document", document);
    _defineProperty(this, "screen", screen);
  }
  return _createClass(Viewport, [{
    key: "getViewportWidth",
    value: function getViewportWidth() {
      /**
       * We want the min of the window inner width and the screen's width here.
       * On rotate the window.innerWidth is too large.
       * On first app boot locally, going from desktop to mobile emulation
       * the screenwidth is too large but window.innerWidth is correct.
       *
       * Taking the min of these two values looks like it's always correct.
       */
      var screenWidth = this.screen.availWidth;
      if (this.window && this.window.innerWidth) {
        screenWidth = Math.min(this.window.innerWidth, screenWidth);
      }
      return Math.max(this.document.documentElement.clientWidth, screenWidth);
    }
  }, {
    key: "getViewportHeight",
    value: function getViewportHeight() {
      return Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0);
    }
  }]);
}();
var _default = exports["default"] = Viewport;